<template>
  <div class="position-absolute trends">
    <b-row>
      <b-col>
        <b-row>
          <b-col class="trend-content">
            <div class="default" v-if="currentTab === null">
              <h3>TRENDS SHAPING THE INDUSTRY</h3>
              <p>Click each trend to learn more</p>
            </div>
            <div v-if="currentTab === 'demand'">
              <h3>Market demand</h3>
              <ul>
                <li>Population, urbanization</li>
                <li>Market volatility as a new normal</li>
              </ul>
            </div>
            <div v-if="currentTab === 'resources'">
              <h3>Resources</h3>
              <ul>
                <li>Market push for sustainable, low carbon production</li>
                <li>Decarbonization</li>
              </ul>
            </div>
            <div v-if="currentTab === 'costs'">
              <h3>Cost pressures</h3>
              <ul>
                <li>The industry is under increasing pressure to become more profitable</li>
              </ul>
            </div>
            <div v-if="currentTab === 'workforce'">
              <h3>Workforce</h3>
              <ul>
                <li>Skill gaps</li>
                <li>New skills required</li>
                <li>Next generation workers</li>
              </ul>
            </div>
          </b-col>
        </b-row>
        <b-row class="nav-links position-relative">
          <div class="line position-absolute"></div>
          <b-col
            v-for="link in tabs"
            :key="link.id + 'Tab'"
          >
            <!-- dot -->
            <div class="nav-link" :class="active(link.id)" @click="tab(link.id)">
              <div class="position-relative dots">
                <div class="position-absolute outline dot">
                </div>
                <div class="position-absolute inactive dot">
                </div>
                <div class="position-absolute active dot" v-if="link.id === currentTab">
                </div>
              </div>
              {{ link.title }}
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentTab: null,
      tabs: [
        {
          id: 'demand',
          title: 'Market demand'
        },
        {
          id: 'resources',
          title: 'Resources'
        },
        {
          id: 'costs',
          title: 'Cost pressures'
        },
        {
          id: 'workforce',
          title: 'Workforce'
        }
      ]
    }
  },
  methods: {
    active (tab) {
      if (tab === this.currentTab) {
        return 'active'
      }
      return null
    },
    tab (tab) {
      this.currentTab = tab
    }
  },
  name: 'Trends'
}
</script>

<style lang="scss" scoped>
.trends {
  bottom: 7%;
  width: 100%;

  .line {
    background: url('../assets/img/home/yellow-trend-line-no-ellipses.svg') no-repeat;
    background-size: 100%;
    left: -7%;
    top: 15px;
    width: 200%;
    height: 2px;
  }

  .nav-links {
    min-width: 740px;
    width: 50%;

    .nav-link {
      color: var(--white);
      text-align: center;
      white-space: nowrap;

      &:hover {
        cursor: pointer;
      }

      &.active {
        color: var(--yellow);
      }

      .dot {
        border-radius: 10px;
        left: 50%;
        top: 0;
        transform: translateX(-50%);

        &.active, &.outline {
          background: var(--yellow);
          top: -2px;
        }

        &.active {
          width: 20px;
          height: 20px;
        }

        &.inactive {
          background: var(--blue);
          width: 16px;
          height: 16px;
        }

        &.outline {
          width: 20px;
          height: 20px;
        }
      }

      .dots {
        margin-bottom: 20px;
      }
    }
  }

  .nav-links, .trend-content {
    margin-left: 3%;
  }
}
</style>
